<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/S7XEUi/tc-custom/9781625676092.jpg?1684274264989" alt="This image is the cover for the book Like A Boss, Occupied Space"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Like A Boss, Occupied Space
      </h1>
      <p class="bookDescription body article font2">
        <p>In the incendiary sequel to <i>Windswept</i>, two-fisted labor organizer Padma Mehta’s worst nightmare comes true: she gets yanked out of early retirement.<br/><br/>Up to her eyeballs in debt, Padma learns that her archenemy Evanrute Saarien has gotten out of prison and started a church with one doctrine: strike. The Union President comes to Padma with an offer she can’t refuse: stop the strike, and her trillion-yuan debt will be forgiven. Will she succeed? Of course not. But she’ll go down swinging...<br/><br/>Newly reissued, this Author's Preferred Edition features essays, stories, and a second recipe for chicken tacos even better than the first.<br/><br/><b>Praise for <i>Like A Boss</i>:</b><br/>“<i>Like A Boss</i> is <b>one of those rare, perfect novels</b> that somehow packs huge ideas into a story that is simultaneously wildly speculative and completely digestible. <i>Like A Boss</i> lives up to its name.<b> A masterwork of big ideas, perfectly executed</b>.”– Ted Kosmatka, author of <i>The Flicker Men</i><br/><br/>“The moment I began reading this, I immediately had to put the book down. <b>I was simply too sick with envy at Adam’s talent.</b>” — Madeline Ashby, acclaimed author of <i>vN</i> and <i>iD</i><br/><br/>“<i>Like A Boss</i> is a laugh-in-your-face rejection of grimdark cynicism and cyberpunk dystopia. It’s a flag-waving, singing-out-loud <b>celebration of people doing the right thing</b> even though it will be hard (and conscious of the cost to themselves), because they know it’s the right thing to do, damn it. <b>It’s a celebration of hope and trust and community.</b> I loved it.” – <i>X + 1</i><br/><br/>“It’s gloriously entertaining SF. Better yet, it’s <b>positive, hopeful, idealistic SF</b>.” — <i>One More</i><br/><br/>“Near the climax of <i>Like A Boss</i> [Padma] delivers a little economic speech that <b>makes as strong a case for unions that I’ve read this year</b>.” — <i>The Seattle Review of Books</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Adam Rakunas
      </h2>
      
      <p class="authorDescription body article">Adam Rakunas was born, raised, and educated in Southern California. He now lives in the Pacific Northwest. These things are related.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      JABberwocky Literary Agency, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1609e626